"use client";

import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import { CareerLookFor } from "src/utils/mock/CareersData";

const CareerLookSection = () => {
  const items = CareerLookFor.flatMap((group) => group.items || []);

  return (
    <section id="career-expectations" className="relative w-full  font-body py-10! md:py-12! !px-6 overflow-hidden">
      <div className="relative w-full max-w-[2200px] mx-auto grid grid-cols-1 lg:grid-cols-[0.7fr_2.3fr] gap-10 items-start lg:pl-16 xl:pl-24">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="lg:sticky lg:top-28! !pt-6 lg:pl-8! lg:-translate-x-0"
        >
          <div className="flex items-center gap-4 mb-4!">
            <h3 className="text-xl sm:text-2xl font-medium uppercase text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-purple-600 dark:from-cyan-400 dark:to-purple-600">
              Expectations
            </h3>
            <span className="w-16 h-[2px] bg-gradient-to-r from-cyan-600 to-purple-600 dark:from-cyan-400 dark:to-purple-600 rounded-full"></span>
          </div>

          <h2 className="!mt-2 text-text-primary leading-[1.05] tracking-[-0.05em] lg:text-[40px] text-[30px]">What Tycho Expects</h2>

          <p className="!mt-3 text-text-secondary  text-[15px] leading-[1.7] max-w-[280px]">
            We look for people who bring ownership, clarity, and strong collaboration into every project they touch.
          </p>
        </motion.div>
        <div className="w-full px-6! lg:px-0!">
          <div className="relative border-t border-b border-border-primary" style={{ background: "var(--card-background)" }}>
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(59,130,246,0.08),transparent_45%)] pointer-events-none" />

            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4">
              {items.map((item, index) => (
                <motion.div
                  key={item.heading || index}
                  initial={{ opacity: 0, y: 25 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{
                    duration: 0.45,
                    delay: index * 0.08,
                  }}
                  className={` relative !px-4 sm:!px-5 md:!px-6 !py-10 sm:!py-12 md:!py-14  border-border-primary border-b sm:border-b xl:border-b-0 min-h-auto sm:min-h-[300px]
                    xl:min-h-[330px]  flex flex-col `}
                >
                  <div className="flex flex-col sm:flex-row items-start sm:items-start !gap-4 h-full">
                    <div className="shrink-0 pt-1 self-center sm:self-auto">
                      {item.icon ? (
                        <Image
                          src={item.icon}
                          alt={item.heading}
                          width={48}
                          height={48}
                          className="w-[48px] h-[48px] object-contain opacity-100"
                          onError={(e) => {
                            e.currentTarget.style.display = "none";
                          }}
                        />
                      ) : (
                        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#5f72ff] to-[#c084fc]" />
                      )}
                    </div>

                    <div className="flex flex-col w-full sm:w-[140px] pt-[2px] text-left">
                      <div className="min-h-auto sm:min-h-[74px] flex items-start">
                        <h4 className="text-text-primary font-bold leading-[1.8] text-[1.05rem] md:text-[1.1rem] break-words">{item.heading}</h4>
                      </div>

                      <p className="text-text-secondary leading-[2.05] text-[14px] md:text-[15px] !mt-1 break-words">{item.content}</p>
                    </div>
                  </div>

                  {index !== items.length - 1 && <div className="hidden xl:block absolute right-0 top-1/2 -translate-y-1/2 h-[55%] w-px bg-border-primary" />}
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareerLookSection;
